<div class="anexo-modern" *ngIf="appearance === 'modern'">
  <div class="anexo-modern__icon">
    <app-svg-icon src="../../../../assets/icons/clip-icon.svg" color="white" width="18px" height="18px"></app-svg-icon>
  </div>
  <div class="anexo-modern__content">
    <p class="anexo-modern__title">Anexos</p>
    <ng-container *ngFor="let anexo of anexos">
      <div class="anexo-modern__item" *ngIf="anexo.visible && anexo.AllowDownload">
        <button type="button" class="anexo-modern__pill" (click)="handleDownloadFile(anexo.File, anexo.Title)">
          {{ modernLabel(anexo) }}
        </button>
        <span class="anexo-modern__caption" *ngIf="modernEmittedCaption(anexo)">{{ modernEmittedCaption(anexo) }}</span>
      </div>
    </ng-container>
    <p class="anexo-modern__empty" *ngIf="!hasDownloadableAnnex">Nenhum anexo disponível</p>
  </div>
</div>

<div class="d-flex column-gap-24" *ngIf="appearance === 'legacy'">
  <ng-container *ngFor="let anexo of anexos; let i = index">
    <div class="d-flex column-gap-5" *ngIf="anexo.visible">
      <ng-container>
        <input
          type="file"
          class="input"
          id="{{ anexo.Id + '_' + index }}"
          accept="application/pdf, .pdf"
          (change)="selectFile($event, anexo.Title)"
          [disabled]="batchType === 'invoice' || anexo.Title === Annex.MemoriaCalculo ||  anexo.DisableUpload" />
        <label
          class="d-flex justify-center align-center"
          [ngClass]="{ 'input-icon': transferType === 'automatic', 'input-manual': transferType === 'manual'}" for="{{ anexo.Id + '_' + index }}"
          [matTooltip]="anexo.Title">
          <ng-container [ngSwitch]="anexo.Title">
            <app-svg-icon
              *ngSwitchCase="Annex.AutorizacaoRepasse"
              src="../../../../assets/icons/download-icon.svg"
              color="white"
              width="20px"
              height="20px">
            </app-svg-icon>

            <app-svg-icon
              *ngSwitchCase="Annex.NotaFiscal"
              src="../../../../assets/icons/clip-icon.svg"
              color="white"
              width="20px"
              height="20px">
            </app-svg-icon>

            <app-svg-icon
              *ngSwitchCase="Annex.MemoriaCalculo"
              src="../../../../assets/icons/download-icon.svg"
              color="white"
              width="18px"
              height="18px">
            </app-svg-icon>

            <app-svg-icon *ngSwitchCase="Annex.Rpa"
              src="../../../../assets/icons/clip-icon.svg"
              color="white"
              width="18px"
              height="18px">
            </app-svg-icon>

          </ng-container>
        </label>
        <div class="input-box box">
          <span
            *ngIf="
              (!anexo.isLoader && 
              (transferType === 'automatic' || 
              (anexo.Title === Annex.AutorizacaoRepasse && !batch.EconomicGroupAutorizationFile) ||
              (anexo.Title === Annex.NotaFiscal && !batch.IsInvoiced) ||
              (anexo.Title === Annex.MemoriaCalculo && !batch.Calculations) ||
              (anexo.Title === Annex.Rpa && !batch.HasRpa))) ||      
              batchType === 'invoice'" class="box-title">
            {{ anexo.Title }}
          </span>

          <div
            *ngIf="anexo.isLoader"
            class="box-loader loader d-flex"
            [ngClass]="{ 'mt-9': transferType === 'manual' }">
            <mat-spinner [diameter]="diameter" class="load"></mat-spinner>
          </div>

          <div *ngIf="anexo.AllowDownload" class="input-anexo anexo" [ngClass]="{ 'mt-9': transferType === 'automatic' }">
            <button
              class="anexo-btn aling-center"
              (click)="handleDownloadFile(anexo.File, anexo.Title)">
              <span class="anexo-name pr-6">{{ anexo.Title }}</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>